import { Action } from 'redux';
import { PlanPriceSliderStateStructure } from '../interfaces/plan-price-slider.interface';

const INITIAL_STATE: PlanPriceSliderStateStructure = {
  value: null,
  highValue: null
};

const SAVE_VALUE = 'SAVE_VALUE';
const SAVE_HIGH_VALUE = 'SAVE_HIGH_VALUE';
const INIT_VALUE = 'INIT_VALUE';
const INIT_HIGH_VALUE = 'INIT_HIGH_VALUE';
const RESET_VALUE_HIGHVALUE = 'RESET_VALUE_HIGHVALUE';

export class PlanPriceSliderAction implements Action {
  type: string;
  value: number;
  highValue: number;
}

export function saveValue(value: number) {
  return { type: SAVE_VALUE, value };
}
export function saveHighValue(highValue: number) {
  return { type: SAVE_HIGH_VALUE, highValue };
}

export function resetPlanSliderValues() {
  return { type: RESET_VALUE_HIGHVALUE };
}

export function PlanPriceSlider(
  state = INITIAL_STATE,
  action: PlanPriceSliderAction
) {
  const copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case SAVE_VALUE:
      copiedState.value = action.value;
      return Object.assign({}, state, copiedState);
    case SAVE_HIGH_VALUE:
      copiedState.highValue = action.highValue;
      return Object.assign({}, state, copiedState);
      case RESET_VALUE_HIGHVALUE:
        return INITIAL_STATE;
    case INIT_VALUE:
    case INIT_HIGH_VALUE:
    default:
      return state;
  }
}
